import React from "react";
import contextProvider from "../../../contextProvider";
import { withRouter } from "react-router-dom";
import metadata from "../../../../metadata.json";
import _ReactOBaseComponent from "../../../_L0_components/_ReactOBaseComponent";
import { _LoadingWrapper } from "../../../_L0_components/Widgets/_LoadingKit";

import Panel from "../../../_L1_components/Layout/Panel";

class ProbeAbout extends _ReactOBaseComponent {
  constructor(props) {
    var initState = {
      loading: false,
    };
    super(props, initState);
  }

  loadProbeAbout(cb) {
    this.setState(
      {
        loading: true,
      },
      () => {
        this.apiStore.fire("probe_about", {
          data: {
            probeuid: this.props.match.params.probeuid,
          },
          ___onSuccess: (status, data) => {
            if (this.mounted) {
              this.setState({
                data: data,
                loading: false,
              });
            }
          },
        });
      }
    );
  }

  /////////////////////////
  //	Lifecycle methods
  //

  onComponentDidMount() {
    this.mounted = true;
    this.apiStore = this.getAppContext().getApiStoreService();
    this.loadProbeAbout();
  }

  onComponentWillUnmount() {
    this.mounted = false;
  }

  onRender() {
    return (
      <_LoadingWrapper loadingPlug={this.state.loading}>
        <Panel
          className="mb-2 rounded-bottom"
          style={{
            minHeight: "100px",
          }}
        >
          <pre>{this.state.data}</pre>
        </Panel>
        <div className="version-text">
          Build: {metadata.build}-{metadata.time}
        </div>
      </_LoadingWrapper>
    );
  }
}

export default contextProvider(
  withRouter(ProbeAbout),
  //	withDefinedContext(ProbeAbout, 'ProbeAbout', context_exposed_methods),
  {
    define: null,
  }
);
